import { Resource } from 'i18next'

// Automatically load all translations from locales directory 🔥
export default (
  supportedLanguages: string[] = [],
  namespaces: readonly string[] = []
): Resource => {
  const locales: Resource = {}

  namespaces.forEach((namespace) => {
    supportedLanguages.forEach((language) => {
      import(`locales/${language}/${namespace}/translation.json`).then((translation) => {
        locales[language] = {
          ...locales[language],
          [namespace]: translation.default,
        }
      })
    })
  })

  return locales
}
